import { render, staticRenderFns } from "./activity-modal.vue?vue&type=template&id=2f8b551c&scoped=true"
import script from "./activity-modal.vue?vue&type=script&lang=js"
export * from "./activity-modal.vue?vue&type=script&lang=js"
import style0 from "./activity-modal.vue?vue&type=style&index=0&id=2f8b551c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8b551c",
  null
  
)

export default component.exports